import eventTarget from '../../eventTarget.js';
import { Events } from '../../enums/index.js';
import triggerEvent from '../../utilities/triggerEvent.js';
import { coreLog } from '../../utilities/logger.js';
const log = coreLog.getLogger('RenderingEngine', 'attachWebGLContextEvents');
export function attachWebGLContextEvents(offscreenMultiRenderWindow, renderingEngineId, contextIndex = 0) {
    const canvas = offscreenMultiRenderWindow.getOpenGLRenderWindow?.()?.getCanvas?.();
    if (!canvas) {
        return;
    }
    canvas.addEventListener('webglcontextlost', () => {
        log.warn(`CornerstoneRender: WebGL context lost (renderingEngine=${renderingEngineId}, context=${contextIndex})`);
        triggerEvent(eventTarget, Events.WEBGL_CONTEXT_LOST, {
            renderingEngineId,
            contextIndex,
        });
    });
    canvas.addEventListener('webglcontextrestored', () => {
        triggerEvent(eventTarget, Events.WEBGL_CONTEXT_RESTORED, {
            renderingEngineId,
            contextIndex,
        });
    });
}
